/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_4_TitleInputs */

const en_vc_onl_how_4_title = /** @type {(inputs: Vc_Onl_How_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same version as the download`)
};

const zh_vc_onl_how_4_title = /** @type {(inputs: Vc_Onl_How_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与下载版同一个版本`)
};

/**
* | output |
* | --- |
* | "Same version as the download" |
*
* @param {Vc_Onl_How_4_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_4_title = /** @type {((inputs?: Vc_Onl_How_4_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_4_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_4_title(inputs)
	return zh_vc_onl_how_4_title(inputs)
});
export { vc_onl_how_4_title as "vc.onl.how.4.title" }